// extracted by mini-css-extract-plugin
export default {"tableHeader":"DetailsTable_tableHeader__M4YF8","tableBody":"DetailsTable_tableBody__t6fpc","headerData":"DetailsTable_headerData__G0r20","tableData":"DetailsTable_tableData__ekjud"};